import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { useLocation, withRouter } from "react-router-dom"
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Row } from "reactstrap"
import { withTranslation } from "react-i18next"

import Breadcrumbs from "components/Common/Breadcrumb"
import AlertaSemVinculo from "../../components/Common/alerta-sem-vinculo"
import FormFilterCompany from "../../components/Common/form-filter-company"
import usePermission from "helpers/permission/usePermission"
import { getCompanies, getCompaniesValuesByOptions } from "../../helpers/utils"
import { Filters } from "../../common/data/definitions"
import { navegarBreadCrumb } from "../../store/navigator/actions"

import FastfoodMobileConfigTable from "./fastfood-mobile-config-table"

const FastfoodMobileConfigLista = props => {
  const { t } = props
  const ref = useRef()
  const location = useLocation()

  const isInforangra = props.user?.usuario_info !== null
  const possuiVinculo = (props.user?.vinculos || []).some(v => ["A", "T"].includes(v.vinculo_status))

  const usePermissionEdit = usePermission("fastfoodMobileConfig_editar")
  const usePermissionInsert = usePermission("fastfoodMobileConfig_inserir")

  const [companiesOption, setCompaniesOption] = useState([])
  const [companies, setCompanies] = useState([])
  const [filters, setFilters] = useState(null)

  useEffect(() => {
    setCompaniesOption(getCompanies(props.user))
    props.navegarBreadCrumb({ title: "breadcrumb.fastfoodmobile.config.title", link: location.pathname })
    populateFiltros([])
  }, [])

  const populateFiltros = (companiesSelected) => {
    const f = []
    const selecionadas = Array.isArray(companiesSelected) ? companiesSelected : companies
    if (selecionadas && selecionadas.length > 0) {
      f.push({ id: "idEmpresa", value: getCompaniesValuesByOptions(selecionadas) })
    }
    if (isInforangra) f.push({ id: "ignoreCompany", value: true, condition: Filters.equals })
    setFilters(f)
    return f
  }

  const pesquisar = () => {
    populateFiltros(companies)
    setTimeout(() => ref?.current?.search(), 300)
  }

  const onVisualizar = (fastfoodMobileConfig) => {
    props.history.push(`/fastfood-mobile-configuracao/${fastfoodMobileConfig.idEmpresa}?visualizar=true`)
  }

  const onEditar = (fastfoodMobileConfig) => {
    props.history.push(`/fastfood-mobile-configuracao/${fastfoodMobileConfig.idEmpresa}`)
  }

  const onIncluir = () => {
    props.history.push("/fastfood-mobile-configuracao")
  }

  if (!props.user || !possuiVinculo) return <AlertaSemVinculo />

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="breadcrumb.fastfoodmobile.config.title" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Form>
                    <Row>
                      <div className="col col-12 col-md-4 col-lg-3">
                        <FormGroup className="mt-3 mb-0">
                          <FormFilterCompany
                            attribute="companies"
                            value={ companies }
                            description={ t("fastfoodmobile.config.lista.filtro.empresa.label") }
                            setValue={ setCompanies }
                            options={ companiesOption }
                            multiple={ true }
                            hasSelectAll={ !isInforangra }
                          />
                        </FormGroup>
                      </div>
                      <div className="col col-auto align-self-start mt-md-4 pt-1">
                        <div className="mt-3 col col-auto d-flex gap-2">
                          <Button color="primary" className="w-md" onClick={ pesquisar }>
                            { t("fastfoodmobile.config.lista.filtro.botao.buscar") }
                          </Button>
                          { usePermissionInsert && (
                            <Button color="success" className="w-md" onClick={ onIncluir }>
                              { t("fastfoodmobile.config.lista.botao.incluir") }
                            </Button>
                          ) }
                        </div>
                      </div>
                    </Row>
                  </Form>
                </CardBody>
              </Card>

              { filters && (
                <Card>
                  <CardBody>
                    <FastfoodMobileConfigTable
                      ref={ ref }
                      filters={ filters }
                      usePermissionEdit={ usePermissionEdit }
                      onVisualizar={ onVisualizar }
                      onEditar={ onEditar }
                    />
                  </CardBody>
                </Card>
              ) }
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

FastfoodMobileConfigLista.propTypes = {
  t: PropTypes.func,
  user: PropTypes.any,
  history: PropTypes.object,
  navegarBreadCrumb: PropTypes.func
}

const mapStateToProps = state => {
  const { user } = state.Login
  return { user }
}

export default withTranslation()(connect(mapStateToProps, { navegarBreadCrumb })(
  withRouter(FastfoodMobileConfigLista)
))
